import {ReactComponent as ProgressIcon} from '../../../../assets/images/icons/progress.svg';
import {useI18n} from '../../../common/providers/I18nProvider';

interface ProgressTypes {
	slotCount?: number;
	announcedCount?: number;
	toNotifyCount?: number;
}

interface ProgressProp {
	progressData?: ProgressTypes;
}

export default function Progress({progressData}: ProgressProp) {
	const {i18n} = useI18n();

	const data = [
		{
			name: i18n('DASHBOARD.PROGRESS.STATS.1', {count: progressData?.slotCount}),
		},
		{
			name: i18n('DASHBOARD.PROGRESS.STATS.2', {count: progressData?.announcedCount}),
		},
		{
			name: i18n('DASHBOARD.PROGRESS.STATS.3', {count: progressData?.toNotifyCount}),
		},
	];

	const isProgressDataValid = () => {
		if (!progressData) return false;

		return !(progressData.slotCount === 0 && progressData.announcedCount === 0 && progressData.toNotifyCount === 0);
	};

	return (
		<div className='sm:bg-white sm:p-6 sm:rounded-lg'>
			<div className='flex justify-between mb-4 sm:mb-7'>
				<div className='flex items-center'>
					<ProgressIcon className='h-6 w-6 sm:h-7 sm:w-7 lg:h-8 lg:w-8' />
					<span className='text-bold md:text-[20px] font-medium text-black-10 ml-3'>
						{i18n('DASHBOARD.PROGRESS.TITLE')}
					</span>
				</div>
			</div>

			<div className='shadow-lg px-5 py-8 rounded-lg' style={{boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.10);'}}>
				{isProgressDataValid() ? (
					data.map((item) => (
						<div key={item.name} className='mb-4.5 last:mb-0 text-sm lg:text-lg text-black-10'>
							<span>{item.name}</span>
						</div>
					))
				) : (
					<div>
						<span className='text-sm md:text-base'>{i18n('COMMON.NO.RECORDS')}</span>
					</div>
				)}
			</div>
		</div>
	);
}
